<div class="buttonWrapper">
  <label for="newImageUpload" class="function-button animated upload" *ngIf="this.uploadTarget != imageType.COVER">
    <em class="fa fa-cloud-upload"></em> Neues Bild Hochladen
  </label>
  <input id="newImageUpload" type="file" accept=".png" *ngIf="this.uploadTarget != imageType.COVER" (change)="fileChangeEvent($event)" />
  <div class="function-button animated border-left" (click)="rotateCounterClockwise()" [ngClass]="this.uploadTarget == imageType.COVER ? 'upload' : ''">
    90° nach Links drehen
  </div>
  <div class="function-button animated border-left" (click)="rotateClockwise()">90° nach Rechts drehen</div>
  <div class="function-button animated border-left" (click)="toggleMaintainAspectRatio()">
    {{ this.maintainAspectRatio ? 'Freie Auswahl' : 'Angepasste Auswahl' }}
  </div>
  <div class="function-button animated border-left" (click)="initiateSave()">
    <markant-icon colorScheme="light" src="../../assets/svg/m_save.svg"></markant-icon>
    Speichern
  </div>
  <div class="function-button cancel border-left" (click)="cancel()">
    <div>X</div>
  </div>
</div>
<div class="flex-centered cropperContainer">
  <div class="cropperWrapper">
    <image-cropper
      class="nativeImage"
      id="imageCropper"
      [backgroundColor]="'transparent'"
      [imageChangedEvent]="imageChangedEvent"
      [imageFile]="image"
      [imageURL]="imageURL"
      [maintainAspectRatio]="this.maintainAspectRatio"
      [containWithinAspectRatio]="true"
      [resizeToHeight]="this.height"
      [resizeToWidth]="this.width"
      [aspectRatio]="1"
      [roundCropper]="false"
      [canvasRotation]="canvasRotation"
      [transform]="transform"
      [alignImage]="'center'"
      [allowMoveImage]="false"
      [style.display]="showCropper ? null : 'none'"
      format="png"
      (imageCropped)="imageCropped($event)"
      (imageLoaded)="imageLoaded()"
    ></image-cropper>
    <div class="zoomContainer">
      <!-- TODO: The 'tickInterval' property no longer exists -->
      <!-- TODO: The 'vertical' property no longer exists -->
      <mat-slider class="slider" step="1" min="50" max="200" #ngSlider
        ><input
          matSliderThumb
          (change)="zoom({source: ngSliderThumb, parent: ngSlider, value: ngSliderThumb.value})"
          #ngSliderThumb="matSliderThumb"
          value="100"
      /></mat-slider>
      <p class="sliderText text">{{ this.scale * 100 | number: '1.0-0' }}%</p>
    </div>
  </div>

  <div class="cropperWrapper" *ngIf="this.uploadTarget != imageType.COVER">
    <p class="text">Vorschau</p>
    <img class="croppedImage" [src]="croppedImage" [style.border]="croppedImage ? '1px solid black' : 'none'" alt="" />
  </div>

  <div class="cropperWrapper preview" *ngIf="this.uploadTarget == imageType.COVER">
    <p class="text">Vorschau</p>
    <div class="product-card">
      <div class="product-card__warenbereich">
        <span class="product-card__warenbereich-text">{{ productCategory }}</span>
      </div>
      <div class="product-card__media">
        <div class="product-card__media-link">
          <img *ngIf="croppedImage" class="product-card__image" [src]="croppedImage" alt="" />
        </div>
      </div>
      <div class="product-card__body">
        <h3 class="product-card__name" [title]="productName">
          <span class="product-card__name-text">{{ productName }}</span>
        </h3>
        <p class="product-card__startup" [title]="startupName">{{ startupName }}</p>
      </div>
    </div>
  </div>
</div>
